import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const REFERRAL_KEY = 'pyl_ref';

export function useReferralCode(): string | null {
  const [searchParams] = useSearchParams();
  const [refCode, setRefCode] = useState<string | null>(null);

  useEffect(() => {
    const urlRef = searchParams.get('ref');
    if (urlRef) {
      sessionStorage.setItem(REFERRAL_KEY, urlRef);
      setRefCode(urlRef);
    } else {
      const stored = sessionStorage.getItem(REFERRAL_KEY);
      if (stored) setRefCode(stored);
    }
  }, [searchParams]);

  return refCode;
}

export function getReferralCode(): string | null {
  return sessionStorage.getItem(REFERRAL_KEY);
}
